// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5b009b3b","455":"cd2997c0","977":"7779f29d"}[chunkId] + ".chunk.js";
};